import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 180%;
    margin-bottom: 32px;
    text-align: center;
    color: ${theme.colors.gray.dark};
  `}
`

export const Warning = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    text-align: center;
    margin-bottom: 32px;
    margin-top: 16px;
    color: ${theme.colors.error.color};

    svg {
      flex-shrink: 0;
    }
  `}
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
